/**
 * Created by koqiui on 2017-04-12.
 */
// api的默认入口
import { Utils, Ajax } from '../app.base'
import { Routes } from '../app.vues'

// ajax shortcut --------------------------------------
//
let loginPageUrl = "/user/login/jsp";

//未登录或会话失效后转到登陆页面
function handleAjax401(errInfo, jqXHR, status) {
    let url = loginPageUrl;
    if(typeof getAppUrl == 'function') {
        url = getAppUrl(loginPageUrl);
    }
    if(typeof Toast !== 'undefined') {
        var errMsg = errInfo.message || "未登录/未能认证";
        Toast.show(errMsg, 100, 'warning');
    }
    //
    Utils.setPageUrl(url, "_self");
}

function ajax() {
    return Ajax.newOne().on401(handleAjax401);
}

function get(url) {
    return Ajax.get(url).on401(handleAjax401);
}

function post(url) {
    return Ajax.post(url).on401(handleAjax401);
}

function put(url) {
    return Ajax.put(url).on401(handleAjax401);
}

const consts = {
    PLAT_NAME: '商维宝',
    NONE_ID_VALUE: -1,
    SYS_ADMIN_NAME: 'sysadmin'
};

//
export default {
    ajax,
    get,
    post,
    put,
    consts
}




//////////////////
// WEBPACK FOOTER
// ./src/api/index.js
// module id = 14
// module chunks = 1